import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { RoundType } from '@/types'
import { CustomSelectFieldGroup } from '@components-v2/molecules/CustomSelectFieldGroup'
import { observer } from 'mobx-react'

type Props = {
  placeholder: string
  selectedRoundIds: string[]
  setFieldValue: (ids: string[]) => void
}

export const RoundsMultipleSelectField: FC<Props> = observer(({ placeholder, selectedRoundIds, setFieldValue }) => {
  const { t } = useTranslation(['angels-vcs-startups'])

  const onSelect = (id: string): void => {
    const isSelected = selectedRoundIds.includes(id)
    if (isSelected) {
      return
    }

    setFieldValue(selectedRoundIds.concat(id))
  }

  const onUnselect = (id: string): void => {
    const isSelected = selectedRoundIds.includes(id)
    if (!isSelected) {
      return
    }

    setFieldValue(selectedRoundIds.filter((selectedId) => selectedId !== id))
  }

  const onUnselectAll = (): void => {
    setFieldValue([])
  }

  const allItems = [
    { id: RoundType.UNKNOWN, name: t('未設定') },
    { id: RoundType.PRESEED, name: t('プレシード') },
    { id: RoundType.SEED, name: t('シード') },
    { id: RoundType.SERIES_A, name: t('シリーズA') },
    { id: RoundType.SERIES_B, name: t('シリーズB') },
    { id: RoundType.SERIES_C, name: t('シリーズC') },
    { id: RoundType.SERIES_D, name: t('シリーズD') },
    { id: RoundType.SERIES_E, name: t('シリーズE') },
    { id: RoundType.SERIES_F, name: t('シリーズF') },
    { id: RoundType.SERIES_G, name: t('シリーズG') },
    { id: RoundType.ACQUIRED, name: t('買収済み') },
    { id: RoundType.IPO, name: t('IPO済み') },
    { id: RoundType.CLOSED, name: t('非公開') },
  ]

  const selectedItems = allItems.filter((item) => selectedRoundIds.includes(item.id))

  const selectableItems = allItems.map((item) => ({
    instance: item,
    isSelected: selectedRoundIds.includes(item.id),
  }))

  return (
    <CustomSelectFieldGroup
      placeholder={placeholder}
      onSelect={onSelect}
      onUnselect={onUnselect}
      selectedItems={selectedItems}
      selectableItems={selectableItems}
      onUnselectAll={onUnselectAll}
    />
  )
})
